/**=========================================================
 * Module: colors.js
 * Services to retrieve global colors
 =========================================================*/
 
App.factory('colors', ['APP_COLORS', colors => ({
  byName(name) {
    return (colors[name] || '#fff')
  }
})])
